function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st10{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1895",
  transform: "translate(-1727 -10)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Interface-Essential_Multimedia-Controls_button-play-1",
  transform: "translate(1727 10)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_558",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "button-play-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval_279",
  transform: "translate(-207.755 -5811.752)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M223.8,5843.8c8.8,0,16-7.2,16-16s-7.2-16-16-16s-16,7.2-16,16S215,5843.8,223.8,5843.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M223.8,5842.3c3.9,0,7.5-1.5,10.3-4.2c2.7-2.7,4.2-6.4,4.2-10.3c0-3.9-1.5-7.5-4.2-10.3 c-2.7-2.7-6.4-4.2-10.3-4.2c-3.9,0-7.5,1.5-10.3,4.2c-2.7,2.7-4.2,6.4-4.2,10.3c0,3.9,1.5,7.5,4.2,10.3 C216.3,5840.8,219.9,5842.3,223.8,5842.3 M223.8,5843.8c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16 C239.8,5836.7,232.6,5843.8,223.8,5843.8z"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Video-Movies-TV_Controls_controls-play",
  transform: "translate(1737.239 18.349)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_76"
}, /*#__PURE__*/React.createElement("g", {
  id: "controls-play"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape_345",
  className: "st10",
  d: "M0.1,1.1v12.5c0,0.6,0.5,1.1,1.1,1.1c0.2,0,0.4,0,0.5-0.1l11.7-6.2c0.5-0.3,0.7-0.9,0.4-1.4 c-0.1-0.2-0.3-0.3-0.4-0.4L1.6,0.2C1.1-0.1,0.5,0.1,0.2,0.6C0.1,0.8,0.1,1,0.1,1.1L0.1,1.1z"
})))));

function SvgPlayVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.1 32.1",
    style: {
      enableBackground: "new 0 0 32.1 32.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play-video.9203f57e.svg";
export { ForwardRef as ReactComponent };